<template>
  <!-- 页面底部组件 -->
  <div class="common-footer-wrap">
    <!--    联系我们我们期待&nbsp;您的来信-->
    <div
      class="common-width contact-wrap">
      <h2 class="title">联系我们</h2>
      <div class="contact-cont clearfix">
        <div class="contact-left">
          <div class="left-title">CONTACT&nbsp;US</div>
          <div class="left-subtitle">我们期待&nbsp;您的来信</div>
          <el-form :model="ruleForm" :rules="rules" ref="form" class="contact-ruleForm">
            <el-form-item prop="name">
              <el-input v-model="ruleForm.name" placeholder="您的姓名"></el-input>
            </el-form-item>
            <el-form-item prop="phone">
              <el-input v-model="ruleForm.phone" placeholder="您的电话"></el-input>
            </el-form-item>
            <el-form-item prop="demand">
              <el-input type="textarea" v-model="ruleForm.demand" placeholder="您的留言"></el-input>
            </el-form-item>
            <el-button class="submit-btn" @click="handleSendMsg">提交给我们</el-button>
          </el-form>
        </div>
        <div class="contact-right">
          <div class="right-title">准备好开始您的项目了吗？</div>
          <div class="right-subtitle">我们秉承“信商有道连天下”的信念，期待为你提供最优质的服务。</div>
          <div class="right-info">若您有合作意向，请您使用以下方式联系我们，您给我们多大的信任，我们给您多大的惊喜！</div>
          <div class="right-list clearfix">
            <div class="right-list-item">
              <div>
                <!-- <img src="/static/icon/index-icon6.png" /> -->
                <el-image src="/static/icon/index-icon6.png" lazy></el-image>
              </div>
              <div>北京市丰台区西国贸园区优橙·创新中心B座3002室</div>
            </div>
            <div class="right-list-item">
              <div>
                <!-- <img src="/static/icon/index-icon7.png" /> -->
                <el-image src="/static/icon/index-icon7.png" lazy></el-image>
              </div>
              <div>
                010-63943800
                <br/>18511978123
              </div>
            </div>
            <div class="right-list-item">
              <div>
                <!-- <img src="/static/icon/index-icon8.png" /> -->
                <el-image src="/static/icon/index-icon8.png" lazy></el-image>
              </div>
              <div>
                EMAIL：
                <br/>business@51shanglian.com
              </div>
            </div>
          </div>
          <div class="wx-out">
            <div class="wx-cont">
              <img class="img-1" src="/static/icon/index-icon9.png"/>
              <img class="img-2" src="/static/icon/index-icon10.png"/>
              <img class="img-3" src="/static/icon/index-icon11.png"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部链接等部分 start -->
    <div class="common-footer-part2">
      <div class="common-width">
        <div class="common-footer-part2-1 clearfix">
          <div class="fl common-footer-item-1">
            <router-link to="/">
              <img
                class="common-footer-logo"
                src="/static/image/common/footer-logo.png"
                alt="logo"
              />
            </router-link>
            <div class="clearfix">
              <div class="fl ewm-out">
                <img src="/static/icon/index-icon11.png" alt="微信客服"/>
                <span>扫一扫 添加微信客服二维码</span>
              </div>
              <div class="fl ewm-out">
                <img src="/static/image/common/ewm-qq.png" alt="qq客服"/>
                <span>扫一扫 添加QQ客服二维码</span>
              </div>
            </div>
          </div>
          <div class="fl common-footer-item-2">
            <h3 class="title">北京商连信息科技有限公司有限公司</h3>
            <ul class="item-list">
              <li class="clearfix">
                <span class="fl label">电&#12288;&#12288;话：</span>
                <span class="fl info"
                >010-6394-3800&nbsp;&nbsp;&nbsp;&nbsp;18511978123</span
                >
              </li>
              <li class="clearfix">
                <span class="fl label">邮&#12288;&#12288;箱：</span>
                <span class="fl info">business@51shanglian.com</span>
              </li>
              <li class="clearfix">
                <span class="fl label">北京总部：</span>
                <span class="fl info">
                  北京市丰台区西国贸园区优橙·创新中
                  <br/>心B座3002室
                </span>
              </li>
              <li class="clearfix">
                <span class="fl label">成都分部：</span>
                <span class="fl info">成都市高新区天府软件园F区菁蓉汇</span>
              </li>
            </ul>
          </div>
          <div class="fl common-footer-item-4">
            <h3 class="title">关于商连</h3>
            <ul class="item-list">
              <li class="clearfix">
                <router-link class="item" :to="'/'"
                >首页
                </router-link
                >
              </li>
              <li class="clearfix">
                <router-link class="item" :to="'/product'"
                >产品
                </router-link
                >
              </li>
              <li class="clearfix">
                <router-link class="item" :to="'/case'"
                >案例
                </router-link
                >
              </li>
              <li class="clearfix">
                <router-link class="item" :to="'/aboutus'"
                >关于我们
                </router-link
                >
              </li>
              <li class="clearfix">
                <router-link class="item" :to="'/contactus'"
                >联系我们
                </router-link
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="common-footer-part2-2">
          <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#cccccc;">京ICP备16029201号-2</a><br/><br/>
          <span>©2019 北京商连信息科技有限公司 版权所有</span>
        </div>
      </div>
    </div>
    <!-- 页面右侧帮助导航 start  -->
    <div class="common-right-help-wrap mobile-hide">
      <ul class="help-list">
        <li class="item item-qq clearfix" @click="qqConsult">
          <div class="default">
            <span class="icon-out"></span>
            <span class="name">QQ咨询</span>
          </div>
          <div class="detail">
            <span class="info">QQ在线咨询</span>
          </div>
        </li>
        <li class="item item-phone clearfix">
          <div class="default">
            <span class="icon-out"></span>
            <span class="name">电话咨询</span>
          </div>
          <div class="detail">
            <span class="info">010-6394-3800</span>
            <span class="info">185-1197-8123</span>
          </div>
        </li>
        <!--        <li class="item item-wechat clearfix">-->
        <!--          <div class="default">-->
        <!--            <span class="icon-out"></span>-->
        <!--            <span class="name">微信咨询</span>-->
        <!--          </div>-->
        <!--          <div class="detail">-->
        <!--            <span class="info">扫一扫 添加您的专属客服微信</span>-->
        <!--          </div>-->
        <!--          <div class="detail mt10">-->
        <!--            <img src="/static/image/common/common-wechat-ewm.png" />-->
        <!--          </div>-->
        <!--        </li>-->
        <li class="item item-go-top clearfix" @click="goTop">
          <div class="default">
            <span class="go-top-icon el-icon-arrow-up"></span>
          </div>
        </li>
      </ul>
    </div>
    <!-- 页面右侧帮助导航 end  -->
    <!-- 首页定时弹窗 start  -->
    <div
      v-show="settimeoutDialogIsShow"
      ref="settimeoutDialog"
      class="index-settimeout-dialog"
    >
      <div class="cont">
        <h3 class="title">我们能做的，远比您想象的更多</h3>
        <div class="clearfix">
          <div class="fl info">
            <span>免费获取专属需求方案及报价方案</span>
            <br/>
            <span>现在咨询，开启您的专属客服</span>
            <span class="contact-phone">
              400-006-0096
              <br/>185-1197-8123
            </span>
          </div>
          <div class="fl contact-out">
            <span class="btn extend-orange-btn large" @click="qqConsult"
            >在线咨询</span
            >
            <span
              class="btn extend-orange-btn large transparent"
              @click="settimeoutDialogIsShow = false"
            >暂不需要</span
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 首页定时弹窗 end  -->
    <!-- 底部链接等部分 start -->
  </div>
</template>

<script>
import goTop from '@/utils/goTop' // 引入回到顶部方法
import api from '@/api'
// import {getNewDate} from '@/utils'

export default {
  mixins: [{
    data () {
      return {
        goTop: goTop
      }
    }
  }],
  data () {
    // 验证手机号
    var validatePhone = (rule, value, callback) => {
      if (!value || !value.trim()) {
        callback(new Error('请输入您的手机号'))
      } else {
        const reg = /^1[0-9]\d{9}$/
        if (reg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      settimeoutDialogFun: '', // 定时事件方法
      settimeoutDialogIsShow: false, // 定时弹窗是否显示
      hadShowSettimeDialogPaths: [], // 以显示过定是弹窗的路由，已显示过就不再显示
      times: 20000, // 定时弹窗延迟出现时间，单位秒
      bottomScrollePin: false, // 底部滚动部分是否滚动
      name: '', // 姓名
      phone: '', // 手机号
      // 当前页面路由
      currentPath: '/', // 当前页面路由
      // 显示合作伙伴板块的路由path
      showTeamPaths: ['/', '/home', '/service/wechat-applet', '/service/web', '/service/h5', '/service/wechat-public-platform', '/service/app', '/service/database'],
      // 显示联系我们板块的路由path
      showContactusPaths: ['/', '/product', '/case', '/news', '/aboutus', '/service', '/service/wechat-applet', '/service/web', '/service/h5', '/service/wechat-public-platform', '/service/app', '/service/database'],
      ruleForm: {
        name: '',
        phone: '',
        demand: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入您的姓名', trigger: 'blur'}
        ],
        phone: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {validator: validatePhone, trigger: 'blur'}
        ]
      }
    }
  },
  components: {},
  methods: {
    /**
     * 路由改变时，清除所有数据
     **/
    pageInit () {
      // this.settimeoutDialogIsShow = false // 定时弹窗是否显示
      this.name = '' // 姓名
      this.phone = '' // 手机号
      this.currentPath = this.$route.path // 当前页面路由
      // 定时显示咨询弹窗
      // this.setTimeoutDialog()
    },
    /**
     * 底部滚动条绑定滚动事件
     **/
    // onBindBottomScroll () {
    //   let domHeight = document.getElementById('bottom-scroll-dom').clientHeight
    //   let clientHeight = document.documentElement.clientHeight
    //   // 获取页面滚动高度
    //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    //   // 获取滚动元素的父元素距离页面顶部的距离
    //   let offsetTop = document.querySelector('#bottom-scroll-dom').offsetTop
    //   // 设置是否固定
    //   this.bottomScrollePin = scrollTop + clientHeight > offsetTop + domHeight
    // },
    // /**
    //  * 定时显示弹窗
    //  **/
    // setTimeoutDialog () {
    //   console.log('当前页面路由', this.currentPath)
    //   console.log('已显示过定时弹窗的页面', this.hadShowSettimeDialogPaths)
    //   // 路由切换时，将定时事件清除，重新定时
    //   if (this.settimeoutDialogFun) {
    //     console.log('清除已有定时事件')
    //     clearTimeout(this.settimeoutDialogFun)
    //   }
    //   // 判断当前页面是否已显示过定时弹窗，以显示过就不再显示，用户每次打开项目，一个页面只显示一次
    //   if (this.hadShowSettimeDialogPaths.indexOf(this.currentPath) !== -1) {
    //     console.log('当前页面已显示过定时弹窗')
    //     return
    //   }
    //   console.log('当前页面未显示过定时弹窗')
    //   console.log('设置定时事件')
    //   this.settimeoutDialogFun = setTimeout(() => {
    //     console.log('显示定时弹窗')
    //     // 使用快服后，暂时不需要此弹窗，先设置为false
    //     // this.settimeoutDialogIsShow = true
    //     this.settimeoutDialogIsShow = false
    //     this.hadShowSettimeDialogPaths.push(this.currentPath)
    //   }, this.times)
    // },
    // /**
    //  * 提交需求
    //  **/
    // onSubmit () {
    //   // 定义手机号格式检测正则表达式
    //   const reg = /^1[0-9]\d{9}$/

    //   // 检查手机号是否存在
    //   if (!this.phone) {
    //     this.$message.error('请输入手机号')
    //     return
    //   }
    //   // 检查手机号格式是否正确
    //   if (!reg.test(this.phone)) {
    //     this.$message.error('请输入正确的手机号')
    //     return
    //   }
    //   // 检查姓名是否存在
    //   if (!this.name) {
    //     this.$message.error('请输入姓名')
    //     return
    //   }
    //   // 向钉钉机器人发送消息
    //   // 当前时间
    //   let nowTime = getNewDate()
    //   // 发行消息
    //   api.dingdingRobotSendMessage.r({
    //     msgtype: 'markdown',
    //     markdown: {
    //       title: `线索信息`,
    //       text:
    //         '#### 商连官网-用户来信-线索信息\n' +
    //         `> 姓名：${this.name}\n\n` +
    //         `> 手机号：${this.phone}\n\n` +
    //         `> 时间：${nowTime}\n\n` +
    //         `> 来源：商连官网`
    //     },
    //     at: {
    //       atMobiles: [],
    //       isAtAll: true
    //     }
    //   }).then((res) => {
    //     console.log('消息已发送')
    //     this.$message({
    //       type: 'success',
    //       message: '需求提交成功，我们会尽快联系您！'
    //     })
    //     this.name = ''
    //     this.phone = ''
    //   })
    //   // // axios发送请求
    //   // const axiosParam = {
    //   //   name: this.name,
    //   //   phone: this.phone
    //   // }
    //   // api.demandCommit.r(axiosParam).then((res) => {
    //   //   if (res.stat === 'OK') {
    //   //     this.name = ''
    //   //     this.phone = ''
    //   //     this.$message({
    //   //       type: 'success',
    //   //       message: '需求提交成功，我们会尽快联系您！'
    //   //     })
    //   //   } else {
    //   //     this.$message({
    //   //       type: 'error',
    //   //       message: res.result
    //   //     })
    //   //   }
    //   // })
    // },
    /**
     * 提交
     **/
    handleSendMsg () {
      this.$refs.form.validate((vali) => {
        if (vali) {
          this.axiosSendMsg()
        }
      })
    },
    /**
     * axios 发送邮件
     **/
    axiosSendMsg () {
      // 向钉钉机器人发送消息
      // 当前时间
      let nowTime = this.getNewDate()
      // 发行消息
      api.dingdingRobotSendMessage.r({
        msgtype: 'markdown',
        markdown: {
          title: `线索信息`,
          text:
            '#### 商连官网-用户来信-线索信息\n' +
            `> 姓名：${this.ruleForm.name}\n\n` +
            `> 手机号：${this.ruleForm.phone}\n\n` +
            `> 需求描述：${this.ruleForm.demand}\n\n` +
            `> 时间：${nowTime}\n\n` +
            `> 来源：商连官网`
        },
        at: {
          atMobiles: [],
          isAtAll: true
        }
      }).then((res) => {
        console.log('消息已发送')
        this.$message({
          type: 'success',
          message: '需求提交成功，我们会尽快联系您！'
        })
        this.$refs.form.resetFields()
      })
      // const axiosParam = {
      //   name: '（商连官网）' + this.ruleForm.name,
      //   phone: this.ruleForm.phone,
      //   demand: this.ruleForm.demand
      // }
      // // 过滤< 和 > 字符
      // let axiosParamStr = JSON.stringify(axiosParam)
      // let axiosParamStrNew1 = axiosParamStr.replace(/</g, '')
      // let axiosParamStrNew2 = axiosParamStrNew1.replace(/>/g, '')
      // let axiosParamNew = JSON.parse(axiosParamStrNew2)

      // api.demandCommit.r(axiosParamNew).then((res) => {
      //   this.$refs.form.resetFields()
      //   this.$message({
      //     type: 'success',
      //     message: '需求提交成功，我们会尽快联系您！'
      //   })
      // })
    },
    // 获取特定格式的日期时间  "yyyy-MM-dd HH:MMM:SS"
    getNewDate () {
      var date = new Date()
      console.log(date)
      var transverse = '-'
      var Verticalpoint = ':'
      var month = date.getMonth() + 1 // 获取月份
      var strDate = date.getDate() // 获取具体的日期
      var strHour = date.getHours() // 获取...钟点
      var strMinute = date.getMinutes() // 获取分钟数
      var strSeconde = date.getSeconds() // 获取秒钟数
      // 判断获取月份 、 具体的日期 、...钟点、分钟数、秒钟数 是否在1~9
      // 如果是则在前面加“0”
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 1 && strDate <= 9) {
        strDate = '0' + strDate
      }
      if (strHour >= 1 && strHour <= 9) {
        strHour = '0' + strHour
      }
      if (strMinute >= 1 && strMinute <= 9) {
        strMinute = '0' + strMinute
      }

      if (strSeconde >= 1 && strSeconde <= 9) {
        strSeconde = '0' + strSeconde
      }
      // 时间日期字符串拼接
      var NewDate = date.getFullYear() + transverse + month + transverse + strDate + ' ' +
        strHour + Verticalpoint + strMinute + Verticalpoint + strSeconde
      // 返回拼接字符串
      return NewDate
    }
  },
  watch: {
    '$route' (to, from) {
      // 页面初始化
      this.pageInit()
    }
  },
  mounted () {
    console.log('绑定滚动事件')
    // 启动监听，底部滚动条绑定滚动事件
    // window.addEventListener('scroll', this.onBindBottomScroll)
  },
  created () {
    // 页面初始化
    this.pageInit()
  },
  beforeDestroy () {
    console.log('销毁滚动事件')
    // window.removeEventListener('scroll', this.onBindBottomScroll)
  }
}
</script>

<style scoped>

.common-footer-part1 {
  padding: 0.3rem;
  background: url("/static/image/common/footer-bg1.jpg") no-repeat center center;
  background-size: cover;
  color: #fff;
  text-align: center;
}

.common-footer-part1-in {
  padding: 0.3rem;
  border: 1px solid #ccc;
}

.common-footer-part1-in .title {
  font-size: 0.32rem;
}

.common-footer-part1-in .hr {
  display: block;
  width: 0.8rem;
  margin: 0.2rem auto 0.32rem;
}

.common-footer-part1-in .info {
  font-size: 0.28rem;
  margin-bottom: 0.4rem;
}

.common-footer-part2 {
  padding-top: 0.7rem;
  background-color: #2c3033;
}

.common-footer-item-1 {
  width: 4.6rem;
}

.common-footer-logo {
  display: block;
  height: 0.5rem;
  margin-bottom: 0.2rem;
}

.common-footer-item-1 .ewm-out {
  width: 0.94rem;
  text-align: center;
  margin-right: 0.56rem;
  color: #fff;
  font-size: 0.12rem;
}

.common-footer-item-1 .ewm-out img {
  display: block;
  width: 100%;
  margin-bottom: 0.08rem;
}

.common-footer-part2 {
  color: #ccc;
}

.common-footer-part2 .title {
  color: #fff;
  font-size: 0.2rem;
}

.common-footer-part2 .item-list {
  margin: 0.13rem 0 0;
  line-height: 0.34rem;
}

.common-footer-part2 .item-list .item {
  color: #ccc;
}

.common-footer-part2 .item-list .item:hover {
  color: #fff;
}

.common-footer-item-2 {
  width: 5rem;
}

.common-footer-part2-2 {
  display: block;
  color: #ccc;
  padding: 0.3rem 0;
  text-align: center;
  border-top: 1px solid #41474f;
}

.common-footer-part2-3 {
  color: #ccc;
  padding: 0.2rem 0;
  margin-top: 0.23rem;
  text-align: center;
  border-top: 1px solid #41474f;
}

.common-footer-part2-3 .friend-link {
  margin-right: 20px;
  color: #ccc;
}

.common-footer-part2-3 .friend-link:hover {
  color: #fff;
}

.common-right-help-wrap {
  position: fixed;
  z-index: 20;
  right: 0.1rem;
  top: 40%;
  margin-top: -1.6rem;
  font-size: 0.15rem;
  text-align: center;
}

.common-right-help-wrap .help-list .item {
  position: relative;
  margin-top: 0.1rem;
  max-width: 1.5rem;
  cursor: pointer;
}

.common-right-help-wrap .help-list .item:first-child {
  margin-top: 0;
}

.common-right-help-wrap .help-list .item .default {
  float: right;
  width: 0.8rem;
  height: 0.8rem;
  padding-top: 0.16rem;
  box-sizing: border-box;
  background-color: #ff563e;
  color: #fff;
}

.common-right-help-wrap .help-list .item .detail {
  display: none;
  float: right;
  width: 1.46rem;
  min-height: 0.8rem;
  box-sizing: border-box;
  padding: 0.16rem;
  border: 1px solid #ff563e;
  background: #fff;
  color: #ff563e;
  line-height: 0.23rem;
}

.common-right-help-wrap .help-list .item.item-qq .detail {
  padding-top: 0.27rem;
}

.common-right-help-wrap .help-list .item:hover .detail {
  display: block;
}

.common-right-help-wrap .help-list .item:not(.item-go-top):hover .default {
  display: none;
}

/* .common-right-help-wrap .help-list .item-wechat .info {
  display: block;
  font-size: 0.12rem;
  line-height: 0.16rem;
  margin-top: 0.04rem;
} */
.common-right-help-wrap .item .icon-out {
  display: block;
  width: 0.26rem;
  height: 0.26rem;
  margin: 0 auto 0.04rem;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}

.common-right-help-wrap .item-qq .icon-out {
  background-image: url("/static/image/common/common-qq-1.png");
}

.common-right-help-wrap .item-qq:hover .icon-out {
  /* background-image: url("/static/image/common/common-qq-1.png"); */
}

.common-right-help-wrap .item-phone .icon-out {
  background-image: url("/static/image/common/common-phone-1.png");
}

.common-right-help-wrap .item-phone:hover .icon-out {
  /* background-image: url("/static/image/index/index-help-icon-phone2.png"); */
}

.common-right-help-wrap .item-wechat .icon-out {
  background-image: url("/static/image/common/common-wechart-1.png");
}

.common-right-help-wrap .item-wechat:hover .icon-out {
  /* background-image: url("/static/image/index/index-help-icon-wechat2.png"); */
}

.common-right-help-wrap .help-list .item.item-go-top {
  padding-top: 0;
  font-size: 0.3rem;
}

.common-bottom-scroll-wrap {
  width: 100%;
  height: 0.8rem;
}

.common-bottom-scroll-main {
  position: fixed;
  z-index: 10;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0.8rem;
  box-sizing: border-box;
  padding-top: 0.22rem;
  background: rgba(255, 86, 62, 0.94);
}

.common-bottom-scroll-wrap.not-fixed .common-bottom-scroll-main {
  position: static;
}

.common-bottom-scroll-main .title {
  float: left;
  font-size: 0.26rem;
  color: #fff;
}

.mr44 {
  margin-right: 0.44rem;
}

.mr24 {
  margin-right: 0.24rem;
}

.index-settimeout-dialog {
  position: fixed;
  width: 6.6rem;
  height: 3.28rem;
  box-sizing: border-box;
  z-index: 1100;
  left: 50%;
  top: 50%;
  padding: 0.1rem;
  transform: translate(-50%, -50%);
  background: rgba(255, 86, 62, 0.94);
  color: #fff;
}

.index-settimeout-dialog .cont {
  padding: 0.36rem 0.4rem;
  border: 1px solid #fff;
}

.index-settimeout-dialog .title {
  margin-bottom: 0.2rem;
  font-size: 0.34rem;
}

.index-settimeout-dialog .info {
  width: 3.58rem;
  font-size: 0.18rem;
  line-height: 0.35rem;
}

.index-settimeout-dialog .contact-out {
  width: 2rem;
}

.index-settimeout-dialog .contact-phone {
  display: block;
  font-size: 0.28rem;
  line-height: 0.48rem;
}

.index-settimeout-dialog .contact-out {
  padding-top: 0.28rem;
}

.index-settimeout-dialog .contact-out .btn + .btn {
  margin-top: 0.3rem;
}

/*联系我们我们期待&nbsp;您的来信 s*/
.contact-wrap {
  width: 1200px;
  margin: 0 auto 112px;
}

.contact-wrap .title {
  font-size: 36px;
  padding: 100px 0 70px;
  margin: 0;
  text-align: center;
}

.contact-wrap .contact-cont {
  box-shadow: 6px 6px 26px 0px rgba(165, 173, 184, 0.16);
}

.contact-wrap .contact-left {
  float: left;
  width: 350px;
  height: 490px;
  box-sizing: border-box;
  padding: 0 65px;
  overflow: hidden;
  background: #09479e;
}

.contact-wrap .left-title {
  padding-top: 40px;
  font-size: 30px;
  color: #fff;
}

.contact-wrap .left-subtitle {
  padding-bottom: 40px;
  font-size: 18px;
  color: #fff;
}

.contact-wrap .contact-right {
  float: right;
  width: 850px;
  height: 490px;
  overflow: hidden;
  text-align: center;
}

.contact-wrap .right-title {
  color: rgba(9, 71, 158, 1);
  font-size: 20px;
  padding-top: 64px;
  padding-bottom: 6px;
}

.contact-wrap .right-subtitle {
  width: 342px;
  line-height: 28px;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  margin: 0 auto;
  padding-bottom: 30px;
}

.contact-wrap .right-info {
  color: #666;
  font-size: 12px;
}

.contact-wrap .right-list {
  width: 570px;
  margin: 50px auto 0;
  color: #666;
}

.contact-wrap .right-list-item {
  float: left;
  width: 190px;
  text-align: center;
  line-height: 22px;
}

.submit-btn {
  margin-top: 20px;
  color: #09479E !important;
}

.wx-out {
  margin: 42px auto 0;
  border-top: 1px solid #e1e1e1;
  width: 520px;
}

.wx-cont {
  position: relative;
  box-sizing: border-box;
  padding-top: 7px;
  width: 86px;
  height: 40px;
  top: -20px;
  text-align: center;
  margin: 0 auto;
  background: #fff;
}

.wx-cont .img-1,
.wx-cont .img-2 {
  margin: 0 auto;
}

.wx-cont .img-2,
.wx-cont .img-3 {
  display: none;
}

.wx-cont .img-3 {
  position: absolute;
  top: -220px;
  left: -64px;
}

.wx-cont:hover .img-1 {
  display: none;
}

.wx-cont:hover .img-2,
.wx-cont:hover .img-3 {
  display: block;
}

/*联系我们我们期待&nbsp;您的来信 e*/
</style>



// WEBPACK FOOTER //
// src/components/footer.vue